export default "__VITE_ASSET__32b88ff6__"